module.exports = __webpack_public_path__ + "img/le-petit.b6f2725f.png";